import * as React from "react";
import { IDistrict, IMunicipality } from "../../../models/IMunicipalityDistrict";
import { TextInput } from "soprasteria-ui-library";
import { IResidence } from "../../../models/IResidence";
import { PostalAddressInformation } from "../../PostalAddress/PostalAddressInformation";

interface IProps {
    residence: IResidence;
}

export const ResidenceInformation: React.FC<IProps> = ({ residence }) => {

    return (
        <>
            <div className="col-6">
                <TextInput label="Boendenamn" name="readonly" defaultValue={residence.residenceName} readonly inlineLabel />
                <TextInput label="Boendekod" name="readonly" defaultValue={residence.residenceCode} readonly inlineLabel />
                <TextInput label="Boendetyp" name="readonly" defaultValue={residence.residenceTypeName} readonly inlineLabel />
                <TextInput label="Platsantal" name="readonly" defaultValue={residence.capacity.toString()} readonly inlineLabel />
            </div>
            <div className="col-6">
                <TextInput label="Status" name="readonly" defaultValue={residence.residenceStatusName} readonly inlineLabel />
                <TextInput label="SCB kod" name="readonly" defaultValue={residence.municipalityName} readonly inlineLabel />
                <TextInput label="Stadsdel" name="readonly" defaultValue={residence.districtName ?? '-'} readonly inlineLabel />
                <TextInput label="Basområde" name="readonly" defaultValue={`(${residence.baseAreaCode}) ${residence.baseAreaName}`} readonly inlineLabel />
            </div>
            <div className="col-12">
                <hr />
                <h4>Boendeadress</h4>
            </div>
            <PostalAddressInformation address={residence.residenceAddressAddress}
                zipCode={residence.residenceAddressZipCode}
                city={residence.residenceAddressCity}
                phoneNumber={residence.residenceAddressPhoneNumber}
                alternativePhoneNumber={residence.residenceAddressAlternativePhoneNumber}
                showEmailAddress={false} />
            <div className="col-12">
                <hr />
                <h4>Ansvarig person för boendeenhet</h4>
            </div>
            <div className="col-6">
                <TextInput label="Namn" name="responsibleFullName" defaultValue={residence.responsibleFullName} readonly inlineLabel />
                <TextInput label="E-postadress" name="responsibleEmailAddress"  defaultValue={residence.responsibleEmailAddress} readonly inlineLabel />
            </div>
            <div className="col-6">

                <TextInput label="Telefonnummer" name="responsiblePhoneNumber" defaultValue={residence.responsiblePhoneNumber} readonly inlineLabel />
                <TextInput label="Alt. telefonnummer" name="responsibleAlternativePhoneNumber" defaultValue={residence.responsibleAlternativePhoneNumber} readonly inlineLabel />
            </div>
        </>

    )
}